// src/components/vision/VisionImpactSection.tsx
import React from 'react';
import { Card } from '@dopomogai/ui';
import {Button} from '@dopomogai/ui';
import { ArrowRight } from 'lucide-react';
import { renderIcon } from '@dopomogai/utils';

interface ImpactData {
  headline: string;
  summary: string;
  cta: string;
}

interface VisionImpactSectionProps {
  impactData: ImpactData;
  onAction: (actionType: string, payload?: any) => void;
}

export const VisionImpactSection: React.FC<VisionImpactSectionProps> = ({ impactData, onAction }) => {
  return (
    <section className="bg-slate-100 py-20 md:py-24">
      <div className="container mx-auto px-4">
        <Card 
          title={impactData.headline} 
          headerBgColor="bg-emerald-100" 
          icon={renderIcon('shield-check', {size: 24, className: 'text-emerald-700'})}
          className="max-w-4xl mx-auto"
        >
          <div className="flex flex-col items-center text-center">
            <p className="text-lg text-slate-700 max-w-3xl">
              {impactData.summary}
            </p>
            <div className="mt-8">
              <Button
                text={impactData.cta}
                variant="secondary"
                size="lg"
                icon={<ArrowRight size={18} />}
                iconPosition="right"
                onClick={() => onAction('NAVIGATE_TO_PAGE', { path: '/impact' })}
              />
            </div>
          </div>
        </Card>
      </div>
    </section>
  );
};

